import { Controller } from '@hotwired/stimulus'

export default class ConstructionObjectNotesController extends Controller {
  static targets = ['list']

  connect() {
    if (!this.hasListTarget) return

    this.listTarget.scroll({
      top: this.listTarget.scrollHeight,
      behavior: 'smooth'
    })
  }
}
